module.exports = __webpack_public_path__ + "img/Profile.b13f3825.svg";